
import React, { useState, useEffect } from 'react';
import content from '../data/content';
import '../styles/Header.css';

function Header() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { images, interval } = content.header;

  useEffect(() => {
    if (images.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % images.length
      );
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      (prevIndex + 1) % images.length
    );
  };

  return (
    <header id="home" className="header">
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt="VR Project Main Header"
          className={`header-image ${index === currentImageIndex ? 'active' : ''}`}
        />
      ))}
      <div className="header-overlay">
        <h1>面白い仲間たちと<br />面白い未来を創ろう。</h1>
      </div>
      {images.length > 1 && (
        <>
          <button className="header-nav-button prev" onClick={handlePrevImage}>
            ‹
          </button>
          <button className="header-nav-button next" onClick={handleNextImage}>
            ›
          </button>
          <div className="header-indicators">
            {images.map((_, index) => (
              <div
                key={index}
                className={`header-indicator ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        </>
      )}
    </header>
  );
}

export default Header;
